import { Box } from "@mui/material";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { MyTextField } from "../../../components/my-text-field/MyTextField";
import { ValidTextRegExp } from "../../../Constant";
import MyContext from "../../../contexts/MyContext";
import { FormWrapper } from "../FormWrapper";

export const CommuterTicketForm1 = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const [biljettnummerValueErr, setBiljettnummerValueErr] = useState("");
  const validate = async () => {
    if (!myContext.biljettnummerValue.trim()) {
      setBiljettnummerValueErr("required");
    } else {
      if (myContext.biljettnummerValue?.trim().length < 5 || myContext.biljettnummerValue?.trim().length > 12) setBiljettnummerValueErr("bus_commuter_ticket_error_mesg");
      else {
        setBiljettnummerValueErr("");
        myContext.changeActiveSlide((myContext.activeSlide += 1));
      }
    }
  };

  return (
    <MyContext.Consumer>
      {(context) => (
        <React.Fragment>
          <FormWrapper onContinue={validate} hasBackButton={false} number={`1/5`} heading={`${t("commuter_ticket")}`}>
            <p id="required-description" className="margin bottom-0" style={{ marginTop: "0.5rem", width: "100%" }}>
              <Box component="small" color="error.main">
                *
              </Box>
              <small> {t("required_field")}</small>
            </p>
            <MyTextField
              autoComplete="on"
              required={true}
              regExp={ValidTextRegExp}
              helperText={t(biljettnummerValueErr)}
              value={context.biljettnummerValue}
              label={t("ticket_number")}
              onChange={context.changeBiljettnummerValue}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
              maxLength={12}
            />
          </FormWrapper>
        </React.Fragment>
      )}
    </MyContext.Consumer>
  );
};
